import React from 'react';
import cn from 'classnames';
import { Form, Radio } from 'antd';
import { Typography, TYPOGRAPHY_WEIGHT } from '_atoms/Typography';
import { ReactComponent as Star } from 'dist/icons/star.svg';
import type { RatingProps } from './types';
import './rating.scss';

const MAX = 5;

export const Rating: React.FC<RatingProps> = ({ className, required, itemProps, label, error }) => (
  <div className={cn('rating-default', className, { error })}>
    {label !== undefined && (
      <Typography.Label weight={TYPOGRAPHY_WEIGHT.BOLD}>
        {label}
        {!!required && <span> *</span>}
      </Typography.Label>
    )}
    <Form.Item {...itemProps}>
      <Radio.Group className="rating-default__stars-list">
        {Array.from({ length: MAX }, (_, i) => (
          <Radio key={i + 1} className="rating-default__star" value={i + 1}>
            <Star className={cn('rating__star-icon', { filled: i + 1 <= 5 })} />
          </Radio>
        ))}
      </Radio.Group>
    </Form.Item>
    {!!error && <Typography.Caption className="rating-default__error-message">{error}</Typography.Caption>}
  </div>
);
